import React, { useEffect, useState } from 'react'
import firebaseGetImageUrl from '../../../helpers/firebaseGetImageUrl'

function ImageContainer({ imageUrl, onRemove }) {
  const [image, setImage] = useState("")

  useEffect(() => {
    const loadImage = async () => {
      const img = await firebaseGetImageUrl(imageUrl, 512, 2);
      setImage(img)
    }
    loadImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{
      width: window.outerWidth < 400 ? '100%' : 360,
      display: 'inline-block',
      margin: 2,
      position: 'relative'
    }} >
      <img alt="" src={image} style={{ width: '100%' }} />
      <div style={{
        position: 'absolute',
        top: 16,
        right: 16
      }}>
        <button onClick={onRemove} className="btn btn-danger">Remove</button>
      </div>
    </div>
  )
}

export default ImageContainer
